import React from "react";
import { useNavigate } from "react-router-dom";
import { Sparkles, Route, ShieldCheck, Settings2, ChevronRight, MessageSquare } from "lucide-react";
import { Panel } from "./ui";

const scrollTo = (id) => document.getElementById(id)?.scrollIntoView({ behavior: "smooth", block: "start" });

const AiBtn = ({ icon: Icon, title, sub, onClick, testid }) => (
  <button type="button" onClick={onClick} data-testid={testid} className="w-full flex items-center gap-3 px-3.5 py-3 rounded-xl border border-white/10 bg-[#0B1424] hover:border-sky-400/40 text-left transition-colors">
    <Icon size={20} className="text-slate-200 shrink-0" strokeWidth={1.6} />
    <span className="min-w-0"><span className="block text-[13px] text-white font-semibold">{title}</span><span className="block text-[11px] text-slate-400 truncate">{sub}</span></span>
  </button>
);

export function AiAssistant() {
  return (
    <Panel title="" testid="nx-ai" bodyClass="px-4 pb-4 space-y-2.5">
      <div className="flex items-center gap-3 -mt-3 mb-2">
        <span className="w-14 h-14 rounded-full border border-sky-400/50 shadow-[0_0_24px_-4px_rgba(56,189,248,0.6)] flex items-center justify-center bg-[#0A1424]"><Sparkles className="text-[#E9C46A]" size={24} /></span>
        <div><div className="text-white font-display text-[16px] font-semibold">Assistente AI – Striano</div><div className="text-[12px] text-slate-400">Come posso aiutarti oggi?</div></div>
      </div>
      <AiBtn icon={Route} title="Prepara la giornata" sub="Analizza servizi, turni e conflitti" onClick={() => scrollTo("nx-planning")} testid="nx-ai-plan" />
      <AiBtn icon={ShieldCheck} title="Trova opportunità" sub="Preventivi aperti e richieste email" onClick={() => scrollTo("nx-opps")} testid="nx-ai-opps" />
      <AiBtn icon={Settings2} title="Ottimizza la flotta" sub="Proposte di autista e veicolo" onClick={() => scrollTo("nx-planning")} testid="nx-ai-fleet" />
      <AiBtn icon={MessageSquare} title="Chiedi all'assistente" sub="Crea prenotazioni scrivendo o parlando" onClick={() => scrollTo("nx-assistant-bar")} testid="nx-ai-ask" />
    </Panel>
  );
}

const TONE = ["bg-[#D4A72C] text-black", "bg-emerald-500 text-black", "bg-amber-500 text-black", "bg-sky-500 text-black", "bg-slate-400 text-black"];

export function NextActions({ actions, alerts }) {
  const nav = useNavigate();
  const items = [...actions, ...(alerts || []).map(a => ({ kind: "alert", title: a.label, sub: `${a.count} · ${a.hint}`, link: a.link }))];
  const go = (a) => {
    if (a.kind === "assign" || a.kind === "conflict") return scrollTo("nx-planning");
    if (a.kind === "quote") return nav("/preventivi");
    if (a.kind === "email") return nav("/email-ai");
    if (a.link) nav(a.link);
  };
  return (
    <Panel title="Prossime azioni suggerite" badge={items.length} testid="nx-actions" bodyClass="px-3 pb-3 flex flex-col">
      <div className="space-y-2 flex-1">
        {items.slice(0, 4).map((a, i) => (
          <button key={i} type="button" onClick={() => go(a)} data-testid={`nx-action-${i}`} className="w-full flex items-start gap-3 p-3 rounded-xl bg-white/[0.025] border border-white/8 hover:border-[#D4A72C]/40 text-left">
            <span className={`w-6 h-6 rounded-full text-[12px] font-bold flex items-center justify-center shrink-0 ${TONE[i]}`}>{i + 1}</span>
            <span className="min-w-0 flex-1"><span className="block text-[13px] text-white font-semibold">{a.title}</span><span className="block text-[11px] text-slate-400 line-clamp-2">{a.sub}</span></span>
            <ChevronRight size={15} className="text-slate-500 mt-1 shrink-0" />
          </button>
        ))}
        {!items.length && <div className="text-sm text-slate-500 text-center py-8" data-testid="nx-actions-empty">Nessuna azione da fare: giornata in ordine</div>}
      </div>
      <button type="button" onClick={() => nav("/sentinel")} className="mt-3 h-9 rounded-lg bg-[#2A2414] border border-[#D4A72C]/30 text-[12px] text-[#F1D27A] hover:bg-[#3A3118]" data-testid="nx-actions-all">Vedi tutte le segnalazioni</button>
    </Panel>
  );
}
